export default {
  name: "custom-file",

  ui: {
    inputFile: "[js-custom-input]",
    renderFile: "[js-input-file]"
  },

  events: [
    {
      on: "change",
      target: "inputFile",
      handle: "getFileUrl"
    }
  ],

  getFileUrl(e) {
    let self = this;
    let files = e.target.files;

    for (var i = 0; i < files.length; i++) {
      var file = files[i].name;
      console.log(file);
      var extension = file.substr(file.lastIndexOf(".") + 1);

      if (!/(pdf|doc)$/gi.test(extension)) {
        console.log("Veuillez sélectionner une document");
      } else {
        self.ui.renderFile.innerHTML = file;
      }
    }
  }
};
